import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import { mapDtoToArticles, type NewsListType } from "../model";

export const getCurrentNews = async (
  _filter: string,
  pageCount: number,
): Promise<NewsListType> => {
  const searchParams = {
    sort: ["createdAt:desc"],
    pagination: {
      page: pageCount || 1,
      pageSize: 6,
    },
    populate: {
      hero: {
        populate: {
          author: { populate: "*" },
          mainImage: { populate: "*" },
        },
      },
    },
  };

  const articles = strapiClient.collection("articles");

  const list = await articles.find({
    ...searchParams,
  });

  return rebuild(mapDtoToArticles(list)) as NewsListType;
};
